var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyteCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5073 5.20263L10.9454 6.24347C10.998 6.36775 11.1382 6.44543 11.2784 6.44543H12.5053C13.1012 6.44543 13.5569 6.84933 13.5569 7.37752V11.1059C13.5569 11.6341 13.1012 12.038 12.5053 12.038H5.4946C4.89869 12.038 4.44299 11.6341 4.44299 11.1059V7.37752C4.44299 6.84933 4.89869 6.44543 5.4946 6.44543H6.72147C6.87921 6.44543 7.0019 6.36775 7.05448 6.24347L7.49265 5.20263H10.5073ZM6.11212 5.1543H5.4946C4.33642 5.1543 3.15186 5.99427 3.15186 7.37752V11.1059C3.15186 12.4892 4.33642 13.3291 5.4946 13.3291H12.5053C13.6635 13.3291 14.8481 12.4892 14.8481 11.1059V7.37752C14.8481 5.99427 13.6635 5.1543 12.5053 5.1543H11.8878L11.6972 4.70168C11.4957 4.22287 11.0268 3.9115 10.5073 3.9115H7.49265C6.97314 3.9115 6.50423 4.22287 6.30266 4.70168L6.11212 5.1543Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00004 9.98735C9.54533 9.98735 9.98738 9.54531 9.98738 9.00002C9.98738 8.45473 9.54533 8.01269 9.00004 8.01269C8.45474 8.01269 8.0127 8.45473 8.0127 9.00002C8.0127 9.54531 8.45474 9.98735 9.00004 9.98735ZM9.00004 11.2785C10.2584 11.2785 11.2785 10.2584 11.2785 9.00002C11.2785 7.74166 10.2584 6.72156 9.00004 6.72156C7.74167 6.72156 6.72156 7.74166 6.72156 9.00002C6.72156 10.2584 7.74167 11.2785 9.00004 11.2785Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7089 2.92403C16.7089 2.0222 15.9778 1.29113 15.076 1.29113L12.038 1.29113L12.038 -3.43134e-07L15.076 -1.68289e-07C16.6909 -7.53455e-08 18 1.30913 18 2.92403L18 5.96198L16.7089 5.96198L16.7089 2.92403Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29114 2.92403C1.29114 2.0222 2.02222 1.29113 2.92405 1.29113L5.96202 1.29113L5.96202 2.60608e-07L2.92405 1.27814e-07C1.30914 5.72244e-08 -5.72239e-08 1.30913 -1.27813e-07 2.92403L-2.60606e-07 5.96197L1.29114 5.96197L1.29114 2.92403Z",
    fill: "#575757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.076 16.7089C15.9778 16.7089 16.7089 15.9778 16.7089 15.076L16.7089 12.038L18 12.038L18 15.076C18 16.6909 16.6909 18 15.076 18L12.038 18L12.038 16.7089L15.076 16.7089Z",
    fill: "#575757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29114 15.076C1.29114 15.9778 2.02222 16.7089 2.92405 16.7089L5.96202 16.7089L5.96202 18L2.92405 18C1.30914 18 2.26036e-07 16.6909 5.04867e-07 15.076L1.0294e-06 12.038L1.29114 12.038L1.29114 15.076Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteCamera);
export default __webpack_public_path__ + "static/media/syte-camera.353bca12.svg";
export { ForwardRef as ReactComponent };